export default __webpack_public_path__ + "static/media/pulse-promo-full.e5ded050.png";